import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import get from 'lodash.get';
import { connect } from 'react-redux';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import { LinearProgress, Dialog, FlatButton } from 'material-ui';
import { URL_FILE_UPLOAD, URL_FILE_IMPORT } from '../constants.js';
import fetcher from '../helpers/fetcher';
import { guessFieldTypes } from '../helpers/fields';
import CsvPreviewWidget from './CsvPreviewWidget.js';

class FileWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      uploadData: {}
    };
  }

  _stopLoading = () => {
    this.setState({ loading: false });
  };

  _startLoading = () => {
    this.setState({ loading: true });
  };

  _handleOpen = () => {
    this.setState({ open: true });
  };

  _handleClose = () => {
    this.setState({ open: false });
  };

  _handleImport = () => {
    const data = {
      filename: this.state.uploadData.filename,
      project: this.props.value.projectId
    };

    const { newline, delimiter } = this.props.value;
    if (newline) {
      data.newline = newline;
    }
    if (delimiter) {
      data.delimtier = delimiter;
    }

    this._startLoading();
    fetcher
      .post(URL_FILE_IMPORT, data)
      .then(res => {
        this._stopLoading();
        if (this.props.onChange) {
          this.props.onChange({
            ...this.props.value,
            ...this.state.uploadData,
            imported: true
          });
        }
        this.props.showNotification('Data was imported successfully');
        this._handleClose();
      })
      .catch(err => {
        this.props.showNotification('Error while importing data', 'warning');
        this._stopLoading();
      });
  };

  _onDrop = acceptedFiles => {
    //TODO cehck if new file has same headers before adding it
    //upload
    const config = {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round(
          progressEvent.loaded * 100 / progressEvent.total
        );
        //Todo
        console.log('onUploadProgress', percentCompleted);
      }
    };
    const data = new FormData();
    const { delimiter, newline } = this.props.value || {};
    if (delimiter) {
      data.append('delimiter', delimiter);
    }
    if (newline) {
      data.append('newline', newline);
    }
    const file = acceptedFiles[0];
    data.append('file', file);

    this._startLoading();
    fetcher
      .post(URL_FILE_UPLOAD, data, config)
      .then(res => {
        this.props.showNotification(
          'File was uplaoded please check the preview'
        );
        if (this.props.onChange) {
          const fields = Object.keys(get(res, 'data.preview[0]', []));
          const uploadData = {
            data: res.data.preview,
            meta: {
              fields: fields,
              fieldTypes: guessFieldTypes(res.data.preview)
            },
            filename: res.data.filename,
            name: file.name
          };
          this.setState({ uploadData });
          this._handleOpen();
        }
        this._stopLoading();
      })
      .catch(err => {
        this.props.showNotification('Error: while uploding file', 'warning');
        console.log('error while uploadoing', err);
        this._stopLoading();
      });
  };

  render() {
    console.log('FileWidget props', this.props);
    const actions = [
      this.state.loading && <LinearProgress />,
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this._handleClose}
        disabled={this.state.loading}
      />,
      <FlatButton
        label="Import"
        primary={true}
        onClick={this._handleImport}
        disabled={this.state.loading}
      />
    ];
    return (
      <div>
        {this.state.loading && <LinearProgress />}
        <Dropzone
          style={{
            width: 'auto',
            height: 70,
            borderWidth: 1,
            borderColor: 'rgb(102, 102, 102)',
            borderStyle: 'dashed',
            borderRadius: 5,
            padding: 5
          }}
          disabled={this.state.loading}
          onDrop={this._onDrop}
        >
          <p>Drop a file here or click to open the file chooser</p>
        </Dropzone>
        <Dialog
          title="Confirm that the data and import"
          actions={actions}
          modal={true}
          autoScrollBodyContent
          open={this.state.open}
        >
          <CsvPreviewWidget value={this.state.uploadData.data} />
        </Dialog>
      </div>
    );
  }
}

FileWidget.propTypes = {
  onChange: PropTypes.func,
  showNotification: PropTypes.func,
  value: PropTypes.shape({
    projectId: PropTypes.number,
    delimiter: PropTypes.string,
    newline: PropTypes.string
  })
};

export default connect(null, {
  showNotification: showNotificationAction
})(FileWidget);



// WEBPACK FOOTER //
// ./src/components/FileWidget.js